import axios from '@/app/axios'
import User from '@/users/entities/user'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import UserFilter from '@/users/entities/user-filter'

class UsersService {
  public async findOneAsync(id: string) {
    const res = await axios.get<User>(`users/${id}`)
    return Responses.obj(res)
  }

  public async findAllPagedAsync(request: UserFilter) {
    const res = await axios.post<PaginationResponse<User>>(`users/find/paged`, request)
    return Responses.pagedList(res)
  }

  public async findAllAsync(request: UserFilter) {
    const res = await axios.post<User[]>(`users/find/all`, request)
    return Responses.list(res)
  }
}

export default new UsersService()
